import { getCurrentEnvironmentConfig } from '../utils/featureFlags';

// Environment-specific Cognito configuration
export const getCognitoConfig = () => {
  const envConfig = getCurrentEnvironmentConfig();

  // Return null if no Cognito configuration is found
  if (!envConfig.cognito) {
    console.log('No Cognito configuration');
    return null;
  }

  return {
    region: envConfig.cognito.region,
    userPoolId: envConfig.cognito.userPoolId,
    userPoolClientId: envConfig.cognito.userPoolClientId,
    identityPoolId: envConfig.cognito.identityPoolId,
    domain: envConfig.cognito.domain,
    environment: envConfig.name,
  };
};
